import React, { useEffect, useState } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import {
  Dialog,
  DialogTitle,
  Grid,
  Slide,
  IconButton,
  DialogContent,
  Container,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import { Button } from "@material-ui/core";
import CreateClaimManual from "./CreateClaimManual";

const CreateClaim = (props) => {
  const { onChange, setShowSnackbar } = props;
  const [open, setOpen] = useState(false);
  // const email = localStorage.getItem("email");
  const email = localStorage.getItem("email") || "";
  const [createClaim, setCreateClaim] = useState(email.includes("bajaj"));

  useEffect(() => {
    setCreateClaim(email.includes("bajaj"));
  }, [open]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFileChange = (event) => {
    const files = event.target.files[0];
    createClaim === false && onChange(files);
    createClaim === false && handleClose();
  };

  return (
    <div>
      <Button
        variant="text"
        color="inherit"
        onClick={handleClickOpen}
        // startIcon={<AddIcon />}
      >
        Claim Creation
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        //scroll={'paper'}
        maxWidth={createClaim === false ? "md" : "lg"}
        fullWidth
      >
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItem: "space-between",
          }}
        >
          <Grid item>
            <DialogTitle> Create Claim </DialogTitle>
          </Grid>
          <Grid
            item
            onClick={handleClose}
            style={{ cursor: "pointer", padding: 10 }}
          >
            <CloseIcon />
          </Grid>
        </Grid>

        <DialogContent>
          <Container>
            {createClaim === false && (
              <Grid
                container
                style={{
                  padding: "30px",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "space-evenly",
                }}
              >
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    endIcon={<CreateIcon />}
                    style={{ padding: "20px 30px" }}
                    onClick={() => setCreateClaim(true)}
                  >
                    Fill by yourself
                  </Button>
                </Grid>
                <Grid item>
                  <label htmlFor="upload-document">
                    <Button
                      aria-label="Upload"
                      variant="outlined"
                      color="primary"
                      component="span"
                      endIcon={<FileUploadIcon />}
                      style={{ padding: "20px 30px" }}
                    >
                      Upload Excel
                    </Button>
                  </label>
                  {/* {accept block is targeting old excel files too (2003 .xls /2007 .xlsx)}  */}
                  <input
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    //multiple
                    hidden
                    data-testid="uploadDoc"
                    id="upload-document"
                    onChange={handleFileChange}
                  />
                </Grid>
              </Grid>
            )}

            {createClaim === true && (
              <Grid>
                <CreateClaimManual
                  setShowSnackbar={setShowSnackbar}
                  setOpen={setOpen}
                />
              </Grid>
            )}
          </Container>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CreateClaim;
